import texture from '@/assets/images/section/concrete-section.jpg';

/**
 * 下層ページ用コンクリート打ちっぱなし背景。
 * viewport 固定 + cover で端まで敷き、ページ長による倍率差をなくす。
 */
export default function ConcreteTexture() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-[#c4c2be]"
    >
      <img
        src={texture}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
